/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchScreen = {
    properties: {
        leagueMatch: {
            type: 'MatchLeague',
            isRequired: true,
        },
        playerRating: {
            type: 'dictionary',
            contains: {
                type: 'any-of',
                contains: [{
                    type: 'number',
                }, {
                    type: 'null',
                }],
            },
            isRequired: true,
        },
        matchFeed: {
            type: 'array',
            contains: {
                type: 'Post',
            },
            isRequired: true,
        },
        coaches: {
            type: 'MatchCoaches',
            isRequired: true,
        },
        suspendedPlayers: {
            type: 'SuspendedPlayerMatch',
            isRequired: true,
        },
        topScorer: {
            type: 'TopScorer',
            isRequired: true,
        },
        focusedPlayers: {
            type: 'FocusedPlayers',
            isRequired: true,
        },
        history: {
            type: 'MatchSmallList',
            isRequired: true,
        },
        goalDistribution: {
            type: 'GoalDistributionMatch',
            isRequired: true,
        },
        shape: {
            type: 'ShapeComparison',
            isRequired: true,
        },
        standing: {
            type: 'StandingAll',
            isRequired: true,
        },
        punishments: {
            type: 'array',
            contains: {
                type: 'Punishment',
            },
            isRequired: true,
        },
        leagueId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
